(function () {
  'use strict';

  var LIGHTBOX_ID = 'td-zoom-lightbox';
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* ── Lightbox singleton ── */
  function getLightbox() {
    var el = document.getElementById(LIGHTBOX_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = LIGHTBOX_ID;
    el.className = 'td-zoom-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image zoom');
    el.innerHTML =
      '<button type="button" class="td-zoom-lightbox__close" aria-label="Close zoom">' +
        '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '<line x1="16" y1="4" x2="4" y2="16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>' +
      '<div class="td-zoom-lightbox__inner">' +
        '<img class="td-zoom-lightbox__img" src="" alt="" />' +
      '</div>';
    document.body.appendChild(el);

    var closeBtn = el.querySelector('.td-zoom-lightbox__close');
    var inner = el.querySelector('.td-zoom-lightbox__inner');

    closeBtn.addEventListener('click', closeLightbox);
    inner.addEventListener('click', function (e) {
      if (e.target === inner) closeLightbox();
    });
    el.addEventListener('click', function (e) {
      if (e.target === el) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) closeLightbox();
    });

    return el;
  }

  function openLightbox(src, alt) {
    var lb = getLightbox();
    var img = lb.querySelector('.td-zoom-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    // Reset any pinch-zoom transform
    img.style.transform = '';
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lb.querySelector('.td-zoom-lightbox__close').focus();
  }

  function closeLightbox() {
    var lb = document.getElementById(LIGHTBOX_ID);
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Desktop hover-zoom ── */
  function initHoverZoom(mediaEl) {
    if (isTouch) return;

    var zoomSrc = mediaEl.getAttribute('data-zoom-image');
    if (!zoomSrc) return;

    // Create the lens overlay
    var lens = document.createElement('div');
    lens.className = 'td-zoom-lens';
    mediaEl.appendChild(lens);

    var zooming = false;
    var preloaded = false;

    function preloadHiRes() {
      if (preloaded) return;
      preloaded = true;
      var img = new Image();
      img.src = zoomSrc;
    }

    mediaEl.addEventListener('mouseenter', function () {
      preloadHiRes();
    });

    mediaEl.addEventListener('mousemove', function (e) {
      if (!zooming) return;
      var rect = mediaEl.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      lens.style.backgroundPosition = x + '% ' + y + '%';
    });

    mediaEl.addEventListener('click', function (e) {
      // If clicking the zoom trigger button, open lightbox instead
      if (e.target.closest('.td-product__zoom-trigger')) return;

      if (!zooming) {
        lens.style.backgroundImage = 'url(' + zoomSrc + ')';
        mediaEl.classList.add('is-zooming');
        zooming = true;
        // Set initial position
        var rect = mediaEl.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        lens.style.backgroundPosition = x + '% ' + y + '%';
      } else {
        mediaEl.classList.remove('is-zooming');
        zooming = false;
      }
    });

    mediaEl.addEventListener('mouseleave', function () {
      if (zooming) {
        mediaEl.classList.remove('is-zooming');
        zooming = false;
      }
    });
  }

  /* ── Zoom trigger button → lightbox ── */
  function initZoomTrigger(mediaEl) {
    var trigger = mediaEl.querySelector('.td-product__zoom-trigger');
    if (!trigger) return;

    var zoomSrc = mediaEl.getAttribute('data-zoom-image');
    var img = mediaEl.querySelector('img');
    var alt = img ? img.alt : '';

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openLightbox(zoomSrc, alt);
    });
  }

  /* ── Mobile tap → lightbox ── */
  function initTapZoom(mediaEl) {
    if (!isTouch) return;

    var zoomSrc = mediaEl.getAttribute('data-zoom-image');
    if (!zoomSrc) return;

    var img = mediaEl.querySelector('img');
    var alt = img ? img.alt : '';

    mediaEl.addEventListener('click', function (e) {
      if (e.target.closest('.td-product__zoom-trigger')) return;
      openLightbox(zoomSrc, alt);
    });
  }

  /* ── Init ── */
  function init() {
    var zoomables = document.querySelectorAll('.td-product__media--zoomable');
    zoomables.forEach(function (el) {
      initHoverZoom(el);
      initZoomTrigger(el);
      initTapZoom(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
